import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/lazy';

import { overrideProperties } from '@ecp/common/src/style/utils';
import { sizePropTypes } from '@ecp/common/src/style/propTypes';
import SwiperBrandUnstyled from '@ecp/common/src/components/unstyled/swiper/SwiperBrandUnstyled';
import SwiperItem from '@ecp/common/src/components/swiper/mo/component/SwiperItem';
import { ArrowNext, ArrowPrev } from '@ecp/common/src/components/swiper/mo/component/SwiperArrow';
import SwiperBrandPaging from '@ecp/common/src/components/swiper/mo/component/SwiperBrandPaging';

export const StyledRoundedWrapper = styled.div`
  position: relative;

  ${overrideProperties(sizePropTypes, {
    height: '100%',
    width: '100%',
  })};

  .swiper {
    border-radius: ${({ round }) => (round ? '8px' : 0)};
    height: 100%;
    width: 100%;

    &-wrapper {
      transform-style: preserve-3d;
    }
  }

  .swiper-3d .swiper-slide-shadow {
    background: none;
  }
`;

const SwiperBrand = React.forwardRef(({ padding, ...props }, ref) => {
  const additionalProps = {
    rootProps: { style: { padding, width: '100%', height: '100%' } },
    pagingComponent: props.pagingProps && SwiperBrandPaging,
  };
  return (
    <SwiperBrandUnstyled
      ref={ref}
      arrowPrevComponent={ArrowPrev}
      arrowNextComponent={ArrowNext}
      wrapperComponent={StyledRoundedWrapper}
      {...props}
      {...additionalProps}
    />
  );
});

SwiperBrand.propTypes = {
  itemList: PropTypes.array,
  itemProps: PropTypes.object,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  carouselProps: PropTypes.object,
  pagingProps: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
  round: PropTypes.bool,
  padding: PropTypes.string,
};

export const SwiperDefaultProps = {
  carouselProps: {
    delay: 3500,
    spaceBetween: 10,
    autoplay: true,
    navigation: true,
    loop: true,
    centeredSlides: true,
  },
  itemProps: { width: '100%', height: 'auto' },
  itemComponent: SwiperItem,
  width: '100%',
  height: 'auto',
};

SwiperBrand.defaultProps = {
  itemList: [],
  itemProps: {},
  ...SwiperDefaultProps,
};

SwiperBrand.displayName = 'SwiperBrand';

export default SwiperBrand;
